export default "__VITE_ASSET__ABDfu8WH__"